<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Speaker Request'"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
    <!-- Start Contact Area -->
    <section class="section contact-area">
      <div class="container">
        <div class="row justify-content-center">
       
          <div class="col-lg-12 col-12">
            <div class="section-title">
                  <!-- <h2 class="text-white">Speaker request</h2> -->
                </div>
                <div class="contact-address mt-5">
                    <h2 class="text-black text-center">Request a Project Spectrum Speaker for Your Event</h2>
                    <!-- <div class="address mt-2"> -->
                      <!-- <p class="text-black">
              Thank you for your interest in having one of our experts speak at your event. Our booking process is simple and convenient. To get started, use the form below to select the speaker by name and submit details about the event. 
            </p> -->
                    <!-- <p>
                      Thank you for your interest in having one of our experts speak at your event. 
                      Our booking process is simple and convenient. To get started, click the button 
                      below to complete the fillable 
                      <a href="https://business.defense.gov/Portals/57/Speaker%20Request%20Form%20PDF%20entry.pdf" target="_blank" rel="noopener noreferrer">
                        PDF Speaker Request Form
                      </a>. 
                      Once complete, save the file and email it to us at 
                      <a href="mailto:osd.pentagon.ousd-a-s.mbx.osbp-industry-and-engagement@mail.mil">
                        osd.pentagon.ousd-a-s.mbx.osbp-industry-and-engagement@mail.mil
                      </a>.
                    </p>
                </div> -->
              </div>
            <div class="mt-5">
			  
                <!-- <h2 class="pb-4"></h2>
                <b-button
                  variant="outline-dark"
                  class="btn rounded btn-primary theme-btn-secondary"
                  @click="downloadPDF"
                  >SPEAKER REQUEST FORM (FILLABLE PDF)</b-button
                > -->
                
               <!-- <button><a href="https://business.defense.gov/Portals/57/Speaker%20Request%20Form%20PDF%20entry.pdf" target="_blank" class="pdf-button">
                  SPEAKER REQUEST FORM (FILLABLE PDF)
                </a>
                </button>  -->
                <!-- <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfu4oobKSsGjJS4y0pfsui2HjpWeBdT_KIbcYcmXjBWj9Dbug/viewform?embedded=true"  width="100%" height="5000" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> --> 
                <iframe data-v-0af444d8="" allowfullscreen="allowfullscreen" frameborder="0" height="1200px" marginheight="0" marginwidth="0" mozallowfullscreen="" msallowfullscreen="" src="https://forms.osi.apps.mil/Pages/ResponsePage.aspx?id=kQEtEK7uYUexyxqD6G70ReVoSueRHttHk2hx5nY_txpUQVMyUklMNlVMNExPU1lVRDNSU1dDT0ZUSiQlQCN0PWcu&amp;embed=true" webkitallowfullscreen="" width="1200px" data-sleek-frame-id="5b3ed513-7909-42c5-b083-be8243089119" style="border: none; max-width: 100%; max-height: 100vh;"></iframe>
              </div>
          </div>
        </div>  
      </div>
    </section>
    <!-- End Contact Area -->
  </div>
</template>
<script>
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from "./library/widgets/title-text-content.vue";
import { EventBus } from "../utils/eventBus";
export default {
  components: {
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  data() {
    return {
      pdfUrl: 'https://business.defense.gov/Portals/57/Speaker%20Request%20Form%20PDF%20entry.pdf'
    };
  },
  methods: {
    downloadPDF() {
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = 'Speaker_Request_Form.pdf'; // Optional: rename the file if desired
      link.target = '_blank';
      link.click();
    }
  },
  mounted() {
    EventBus.$emit("activate-indicated-menu-item", "Speaker Request");
  }
};
</script>
<style scoped>

.pdf-button {
  display: inline-block;
  padding: 15px 30px;
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  background-color: #2f4c81; /* Adjust to match the blue color */
  text-align: center;
  text-decoration: none;
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Shadow for depth */
}

.pdf-button:hover {
  background-color: #1e355a; /* Darker shade on hover */
}
.form-group {
  margin-bottom: 0px;
}

.link-white {
  color: #f2b636;
}

.link-white:hover {
  text-decoration: underline !important;
}

</style>
